import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { clientRoutes } from "@/lib/clientRoutes";

/**
 * A-Block A0 (AC-A0-05) — no-access landing.
 *
 * Shown when a legacy account id cannot be anchored to an active holding
 * (no active membership, forbidden, or not found). We deliberately do NOT
 * fall back to an arbitrary holding — that would expose the wrong client.
 */
export function NoAccessPage({ reason }: { reason?: string }) {
  const navigate = useNavigate();

  const message =
    reason === "no-active-membership"
      ? "Цей контрагент не належить до жодного активного холдингу, тому картку відкрити не вдалося."
      : reason === "forbidden"
        ? "У вас немає доступу до цього контрагента."
        : reason === "not-found"
          ? "Контрагента не знайдено."
          : "Не вдалося відкрити картку контрагента.";

  return (
    <div className="flex h-full items-center justify-center px-6 py-12">
      <div className="text-center max-w-md space-y-4">
        <div className="mx-auto w-14 h-14 rounded-2xl bg-destructive/10 text-destructive flex items-center justify-center">
          <ShieldAlert className="w-7 h-7" />
        </div>
        <h1 className="text-xl font-semibold tracking-tight">Немає доступу</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <div className="flex justify-center gap-2 pt-2">
          <Button onClick={() => navigate(clientRoutes.list())}>До списку контрагентів</Button>
        </div>
      </div>
    </div>
  );
}
